import React from 'react'
import CreateLogin from '~/views/Popup/views/CreateSubscription/CreateAccount'
import Billing from "~/views/Popup/views/CreateSubscription/Billing";
import popup from "~/views/Popup/popup"
import Verify from './verify'
import Thankyou from './thank-you'
import { trackECommerceEvent } from "~/tools/analytics/googleAnalytics";
import './style.css'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

const  titleMap = {
  'createAccount': ['Create an Account', 'Account Created!'],
  'billing': ['Add Billing', 'Added Billing!'],
  'verify': ['Verify and Pay']
}

class Purchase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      current: props.user ? props.user.billingInfo ? 'verify': 'billing' : 'createAccount',
      plan: props.args.plan,
      content: props.args.content
    }
  }

  isComplete(state) {
    return (
      (state === 'createAccount' && this.state.user) ||
      (state === 'billing' && this.state.user && this.state.user.billingInfo) ||
      (state === 'verify' && false)
    )
  }

  componentDidMount(){
    this.ga = window.ga
    this.dataLayer = window.dataLayer || { push: _ => { } }
    const { content } = this.state
    const currencyCode = content && content.pricing && content.pricing.currency
    if(this.state.current === 'createAccount'){
      this.ga("set", "currencyCode", currencyCode);
      trackECommerceEvent('ec:addProduct', {
        id: this.state.plan.videoID,
        name: this.state.plan.name,
        price: this.state.plan.price,
        quantity: 1
      })
      this.ga('ec:setAction', 'checkout', {
        'step': 1
      })
      this.ga('send', 'event', 'e-commerce', 'checkout-step', '1')
      this.dataLayer.push({
        event: "tvod_purchase_checkout_step_1",
        tvod_content_uuid: this.state.plan.videoID,
        tvod_content_name: this.state.plan.name,
        tvod_content_price: this.state.plan.price
      });
    }
    if (this.state.current === 'billing') {
      this.ga("set", "currencyCode", currencyCode);
      trackECommerceEvent("ec:addProduct", {
        id: this.state.plan.videoID,
        name: this.state.plan.name,
        price: this.state.plan.price,
        quantity: 1
      });
      this.ga("ec:setAction", "checkout", { step: 2 });
      this.ga("send", "event", "e-commerce", "checkout-step", '2');
      this.dataLayer.push({
        event: "tvod_purchase_checkout_step_2",
        tvod_content_uuid: this.state.plan.videoID,
        tvod_content_name: this.state.plan.name,
        tvod_content_price: this.state.plan.price
      });
    }
    if(this.state.current === "verify"){
      this.ga("set", "currencyCode", currencyCode);
      trackECommerceEvent("ec:addProduct", {
        id: this.state.plan.videoID,
        name: this.state.plan.name,
        price: this.state.plan.price,
        quantity: 1
      });
      this.ga("ec:setAction", "checkout", { step: 3 });
      this.ga("send", "event", "e-commerce", "checkout-step", "3");
      this.dataLayer.push({
        event: "tvod_purchase_checkout_step_3",
        tvod_content_uuid: this.state.plan.videoID,
        tvod_content_name: this.state.plan.name,
        tvod_content_price: this.state.plan.price
      });
    }
  }

  componentDidUpdate(prevProps, prevState){
    const { content } = this.state
    const currencyCode = content && content.pricing && content.pricing.currency
    if(this.state.current !== prevState.current){
      if (this.state.current === 'billing'){
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "checkout", { step: 2 });
        this.ga("send", "event", "e-commerce", "checkout-step", '2');
        this.dataLayer.push({
          event: "tvod_purchase_checkout_step_2",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price
        });
      }
      if(this.state.current === 'verfiy') {
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "checkout", { step: 3 });
        this.ga("send", "event", "e-commerce", "checkout-step", "3");
        this.dataLayer.push({
          event: "tvod_purchase_checkout_step_3",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price
        });
      }
      if(this.state.current === 'thankyou'){
        this.ga("set", "currencyCode", currencyCode);
        trackECommerceEvent("ec:addProduct", {
          id: this.state.plan.videoID,
          name: this.state.plan.name,
          price: this.state.plan.price,
          quantity: 1
        });
        this.ga("ec:setAction", "purchase", { 
          id: this.state.user.billingInfo.requestId,
          revenue: this.state.plan.price
        });
        this.ga("send", "event", "e-commerce", "purchase");
        this.dataLayer.push({
          event: "tvod_purchase_completion",
          tvod_content_uuid: this.state.plan.videoID,
          tvod_content_name: this.state.plan.name,
          tvod_content_price: this.state.plan.price,
          transaction_id: this.state.user.billingInfo.requestId
        });
      }
    }
  }
 

  render() {
    var left = -100 * ["createAccount", "billing", "verify"].indexOf(this.state.current) + "%";
    if(this.state.current === 'thankyou'){
      return <div className="purchase-popup subscription-view centered thank-you">
        <Thankyou 
          plan={this.state.plan} 
          content={this.state.content} 
          user={this.state.user} 
          fn={this.props.args.fn} 
        />
      </div>;
    }
    return <div className="purchase-popup subscription-view centered">
      <div className="progress">
        <div className="ticked" key={'film'}>
          {this.state.content.gist.title}
          <div className="bar site-color site-color-after" />
        </div>
        {Object.keys(titleMap).map((v,k) => {
        return <div
          key={k}
          className={
            this.state.current === v ? 'red' :
              this.isComplete(v) ? 'ticked' : ''
          }
          >
          {titleMap[v][(this.isComplete(v) && this.state.current !== k) ? 1 : 0]}
          <div className="bar site-color site-color-after"></div>
          </div>
          })
        }
      </div>
      <div className="screen">
        <div className="slider" style={ { marginLeft: left } }>
          <div className={'slide' + (this.state.current !== 'createAccount' ? ' hidden' : '')}>
            <CreateLogin 
              plan={this.props.args.plan} 
              user={this.state.user} 
              continue={c => { this.setState({ current: 'billing' }) }} 
              editOfferCode={c => this.setState({ editingOfferCode: c })}
              editingOfferCode={this.state.editingOfferCode}
              goToLogin={_ => popup.login()} />
          </div>
          <div className={'slide' + (this.state.current !== 'billing' ? ' hidden' : '')}>
            {(this.state.current === 'billing') && <Billing
              purchase={true}
              plan={this.state.plan}
              user={this.state.user}
              buttonCaption="Continue"
              updateCard={this.state.updateCard}
              saveToken={ (token)=>this.setState({billingToken: token}) }
              editPromo={() => this.setState({ current: 'createAccount'})}
              success={data => this.setState({ subscriptionData: data, current: 'verify' })}
            />}
          </div>
          <div className={'slide' + (this.state.current !== 'verify' ? ' hidden' : '')}>
            <Verify 
              plan={this.state.plan} 
              content={this.state.content} 
              user={this.state.user} 
              edit={() => this.setState({current: 'billing', updateCard: true})}
              success={(id) => {
                this.setState({ purchasedVideoId: id, current: 'thankyou' })
                this.props.setAppState({ refresh: () => window.location.reload() })
                this.props.args.purchase()
              }}
            />
          </div>
        </div>
      </div>
    </div>;
  }
   
}

connect(Purchase, (state) => ({ user: state.user }), userStore)

export default Purchase;
